import './bootstrap';
// alpine should not be used with livewire
// import Alpine from 'alpinejs';
// import focus from '@alpinejs/focus';
// window.Alpine = Alpine;

// Alpine.plugin(focus);

// Alpine.start();

import './algolysis'

jQuery(function () {
    $(".s2").select2({  focus: true });
 });